import { CommonModule } from '@angular/common';
import { Component } from '@angular/core';
import { ControlsModule } from 'src/app/controls/controls.module';
import { SubscriptionService } from 'src/app/core/subscription.service';

@Component({
  selector: 'app-subscription-view',
  templateUrl: './subscription-view.component.html',
  styleUrls: ['./subscription-view.component.scss'],
  standalone: true,
  imports: [
    CommonModule,
    ControlsModule
  ]
})
export class SubscriptionViewComponent {

  currentSubscription: any;
  durationText?: string;
  isTrialSubscription?: boolean;

  constructor(
    private subscriptionService: SubscriptionService
  ) {}

  ngOnInit() {
    this.subscriptionService.getCurrentSubscription().subscribe(subscription => {
      this.currentSubscription = subscription;
    });
  }

  unsubscribeAbo() {
    this.subscriptionService.cancelCurrentSubscription().subscribe(result => console.log(result));
  }
}
